// Mirrors ecregi-api/src/modules/chat/dto/chat.dto.ts → WS_EVENTS.
export const WS_EVENTS = {
  JOIN: 'chat:join',
  LEAVE: 'chat:leave',
  SEND: 'chat:send',
  TYPING: 'chat:typing',
  MARK_READ: 'chat:mark_read',

  MESSAGE_CREATED: 'chat:message_created',
  TYPING_UPDATED: 'chat:typing_updated',
  READ_RECEIPT: 'chat:read_receipt',
  PRESENCE: 'chat:presence',
  ERROR: 'chat:error',
} as const;
